import Vue from 'vue';
import ready from "document-ready-promise";
import store from "./store";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import DetectsWindowSize from "./mixins/DetectsWindowSize";
import GoogleTracking from "./mixins/GoogleTracking";

ready().then(() => {
  new Vue({
    el: "#app",
    store,
    mixins: [
      DetectsWindowSize,
      GoogleTracking,
    ],
    data() {
      return {
        constants: window.App.constants,
        view: window.App.view,
        eventBus: new Vue(),
        modal: null,
        loading: false,
        loadingMessage: "Loading...",
        loadingTheme: "primary",
      };
    },
    computed: {
      user() {
        return this.$store.state.auth.user;
      },
      company() {
        return this.$store.state.auth.company;
      },
      brand() {
        return this.$store.state.auth.brand;
      },
      ...mapGetters([
        "isLoggedIn",
        "isSuperUser",
        "isAdmin",
        "isManager",
        "isStudent",
        "isPublicUser",
        "isTrainer",
        "isFactoryTrainer",
        "isExternalTrainer",
        "isDistributorTrainer",
        "isAuthorizedTrainer",
        "isLocalContact",
        "isDealer",
        "isDistributor",
        "isFactory",
        "isIcpDealer",
        "isAdminager",
      ]),
    },
    methods: {
      showLoading(message, theme) {
        if (!!message) {
          this.loadingMessage = message;
        }
        if (!!theme) {
          this.loadingTheme = theme;
        }
        this.loading = true;
      },
      hideLoading() {
        this.loading = false;
        this.loadingMessage = "Loading...";
        this.loadingTheme = "primary";
      },
    },
  });
});
